/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as EigentuemerRouteImport } from "./routes/eigentuemer";
import { Route as EingangRouteImport } from "./routes/eingang";
import { Route as EinstellungenRouteImport } from "./routes/einstellungen";
import { Route as KostenRouteImport } from "./routes/kosten";
import { Route as MehrRouteImport } from "./routes/mehr";
import { Route as PreisatlasRouteImport } from "./routes/preisatlas";
import { Route as RechnerRouteImport } from "./routes/rechner";
import { Route as SanierungRouteImport } from "./routes/sanierung";
import { Route as VersammlungRouteImport } from "./routes/versammlung";
import { Route as EntscheidungVergleichIdRouteImport } from "./routes/entscheidung/$vergleichId";
import { Route as PreispruefungVertragIdRouteImport } from "./routes/preispruefung/$vertragId";
import { Route as VergleicheIndexRouteImport } from "./routes/vergleiche/index";
import { Route as VergleicheVergleichIdRouteImport } from "./routes/vergleiche/$vergleichId";
import { Route as VertraegeVertragIdRouteImport } from "./routes/vertraege/$vertragId";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const EigentuemerRoute = EigentuemerRouteImport.update({
  id: "/eigentuemer",
  path: "/eigentuemer",
  getParentRoute: () => rootRouteImport,
} as any);
const EingangRoute = EingangRouteImport.update({
  id: "/eingang",
  path: "/eingang",
  getParentRoute: () => rootRouteImport,
} as any);
const EinstellungenRoute = EinstellungenRouteImport.update({
  id: "/einstellungen",
  path: "/einstellungen",
  getParentRoute: () => rootRouteImport,
} as any);
const KostenRoute = KostenRouteImport.update({
  id: "/kosten",
  path: "/kosten",
  getParentRoute: () => rootRouteImport,
} as any);
const MehrRoute = MehrRouteImport.update({
  id: "/mehr",
  path: "/mehr",
  getParentRoute: () => rootRouteImport,
} as any);
const PreisatlasRoute = PreisatlasRouteImport.update({
  id: "/preisatlas",
  path: "/preisatlas",
  getParentRoute: () => rootRouteImport,
} as any);
const RechnerRoute = RechnerRouteImport.update({
  id: "/rechner",
  path: "/rechner",
  getParentRoute: () => rootRouteImport,
} as any);
const SanierungRoute = SanierungRouteImport.update({
  id: "/sanierung",
  path: "/sanierung",
  getParentRoute: () => rootRouteImport,
} as any);
const VersammlungRoute = VersammlungRouteImport.update({
  id: "/versammlung",
  path: "/versammlung",
  getParentRoute: () => rootRouteImport,
} as any);
const EntscheidungVergleichIdRoute = EntscheidungVergleichIdRouteImport.update({
  id: "/entscheidung/$vergleichId",
  path: "/entscheidung/$vergleichId",
  getParentRoute: () => rootRouteImport,
} as any);
const PreispruefungVertragIdRoute = PreispruefungVertragIdRouteImport.update({
  id: "/preispruefung/$vertragId",
  path: "/preispruefung/$vertragId",
  getParentRoute: () => rootRouteImport,
} as any);
const VergleicheIndexRoute = VergleicheIndexRouteImport.update({
  id: "/vergleiche/",
  path: "/vergleiche/",
  getParentRoute: () => rootRouteImport,
} as any);
const VergleicheVergleichIdRoute = VergleicheVergleichIdRouteImport.update({
  id: "/vergleiche/$vergleichId",
  path: "/vergleiche/$vergleichId",
  getParentRoute: () => rootRouteImport,
} as any);
const VertraegeVertragIdRoute = VertraegeVertragIdRouteImport.update({
  id: "/vertraege/$vertragId",
  path: "/vertraege/$vertragId",
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/eigentuemer": typeof EigentuemerRoute;
  "/eingang": typeof EingangRoute;
  "/einstellungen": typeof EinstellungenRoute;
  "/kosten": typeof KostenRoute;
  "/mehr": typeof MehrRoute;
  "/preisatlas": typeof PreisatlasRoute;
  "/rechner": typeof RechnerRoute;
  "/sanierung": typeof SanierungRoute;
  "/versammlung": typeof VersammlungRoute;
  "/entscheidung/$vergleichId": typeof EntscheidungVergleichIdRoute;
  "/preispruefung/$vertragId": typeof PreispruefungVertragIdRoute;
  "/vergleiche/$vergleichId": typeof VergleicheVergleichIdRoute;
  "/vertraege/$vertragId": typeof VertraegeVertragIdRoute;
  "/vergleiche/": typeof VergleicheIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/eigentuemer": typeof EigentuemerRoute;
  "/eingang": typeof EingangRoute;
  "/einstellungen": typeof EinstellungenRoute;
  "/kosten": typeof KostenRoute;
  "/mehr": typeof MehrRoute;
  "/preisatlas": typeof PreisatlasRoute;
  "/rechner": typeof RechnerRoute;
  "/sanierung": typeof SanierungRoute;
  "/versammlung": typeof VersammlungRoute;
  "/entscheidung/$vergleichId": typeof EntscheidungVergleichIdRoute;
  "/preispruefung/$vertragId": typeof PreispruefungVertragIdRoute;
  "/vergleiche/$vergleichId": typeof VergleicheVergleichIdRoute;
  "/vertraege/$vertragId": typeof VertraegeVertragIdRoute;
  "/vergleiche": typeof VergleicheIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/eigentuemer": typeof EigentuemerRoute;
  "/eingang": typeof EingangRoute;
  "/einstellungen": typeof EinstellungenRoute;
  "/kosten": typeof KostenRoute;
  "/mehr": typeof MehrRoute;
  "/preisatlas": typeof PreisatlasRoute;
  "/rechner": typeof RechnerRoute;
  "/sanierung": typeof SanierungRoute;
  "/versammlung": typeof VersammlungRoute;
  "/entscheidung/$vergleichId": typeof EntscheidungVergleichIdRoute;
  "/preispruefung/$vertragId": typeof PreispruefungVertragIdRoute;
  "/vergleiche/$vergleichId": typeof VergleicheVergleichIdRoute;
  "/vertraege/$vertragId": typeof VertraegeVertragIdRoute;
  "/vergleiche/": typeof VergleicheIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/eigentuemer"
    | "/eingang"
    | "/einstellungen"
    | "/kosten"
    | "/mehr"
    | "/preisatlas"
    | "/rechner"
    | "/sanierung"
    | "/versammlung"
    | "/entscheidung/$vergleichId"
    | "/preispruefung/$vertragId"
    | "/vergleiche/$vergleichId"
    | "/vertraege/$vertragId"
    | "/vergleiche/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/eigentuemer"
    | "/eingang"
    | "/einstellungen"
    | "/kosten"
    | "/mehr"
    | "/preisatlas"
    | "/rechner"
    | "/sanierung"
    | "/versammlung"
    | "/entscheidung/$vergleichId"
    | "/preispruefung/$vertragId"
    | "/vergleiche/$vergleichId"
    | "/vertraege/$vertragId"
    | "/vergleiche";
  id:
    | "__root__"
    | "/"
    | "/eigentuemer"
    | "/eingang"
    | "/einstellungen"
    | "/kosten"
    | "/mehr"
    | "/preisatlas"
    | "/rechner"
    | "/sanierung"
    | "/versammlung"
    | "/entscheidung/$vergleichId"
    | "/preispruefung/$vertragId"
    | "/vergleiche/$vergleichId"
    | "/vertraege/$vertragId"
    | "/vergleiche/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  EigentuemerRoute: typeof EigentuemerRoute;
  EingangRoute: typeof EingangRoute;
  EinstellungenRoute: typeof EinstellungenRoute;
  KostenRoute: typeof KostenRoute;
  MehrRoute: typeof MehrRoute;
  PreisatlasRoute: typeof PreisatlasRoute;
  RechnerRoute: typeof RechnerRoute;
  SanierungRoute: typeof SanierungRoute;
  VersammlungRoute: typeof VersammlungRoute;
  EntscheidungVergleichIdRoute: typeof EntscheidungVergleichIdRoute;
  PreispruefungVertragIdRoute: typeof PreispruefungVertragIdRoute;
  VergleicheVergleichIdRoute: typeof VergleicheVergleichIdRoute;
  VertraegeVertragIdRoute: typeof VertraegeVertragIdRoute;
  VergleicheIndexRoute: typeof VergleicheIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/eigentuemer": {
      id: "/eigentuemer";
      path: "/eigentuemer";
      fullPath: "/eigentuemer";
      preLoaderRoute: typeof EigentuemerRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/eingang": {
      id: "/eingang";
      path: "/eingang";
      fullPath: "/eingang";
      preLoaderRoute: typeof EingangRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/einstellungen": {
      id: "/einstellungen";
      path: "/einstellungen";
      fullPath: "/einstellungen";
      preLoaderRoute: typeof EinstellungenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/kosten": {
      id: "/kosten";
      path: "/kosten";
      fullPath: "/kosten";
      preLoaderRoute: typeof KostenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/mehr": {
      id: "/mehr";
      path: "/mehr";
      fullPath: "/mehr";
      preLoaderRoute: typeof MehrRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/preisatlas": {
      id: "/preisatlas";
      path: "/preisatlas";
      fullPath: "/preisatlas";
      preLoaderRoute: typeof PreisatlasRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/rechner": {
      id: "/rechner";
      path: "/rechner";
      fullPath: "/rechner";
      preLoaderRoute: typeof RechnerRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sanierung": {
      id: "/sanierung";
      path: "/sanierung";
      fullPath: "/sanierung";
      preLoaderRoute: typeof SanierungRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/versammlung": {
      id: "/versammlung";
      path: "/versammlung";
      fullPath: "/versammlung";
      preLoaderRoute: typeof VersammlungRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/entscheidung/$vergleichId": {
      id: "/entscheidung/$vergleichId";
      path: "/entscheidung/$vergleichId";
      fullPath: "/entscheidung/$vergleichId";
      preLoaderRoute: typeof EntscheidungVergleichIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/preispruefung/$vertragId": {
      id: "/preispruefung/$vertragId";
      path: "/preispruefung/$vertragId";
      fullPath: "/preispruefung/$vertragId";
      preLoaderRoute: typeof PreispruefungVertragIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/vergleiche/": {
      id: "/vergleiche/";
      path: "/vergleiche";
      fullPath: "/vergleiche/";
      preLoaderRoute: typeof VergleicheIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/vergleiche/$vergleichId": {
      id: "/vergleiche/$vergleichId";
      path: "/vergleiche/$vergleichId";
      fullPath: "/vergleiche/$vergleichId";
      preLoaderRoute: typeof VergleicheVergleichIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/vertraege/$vertragId": {
      id: "/vertraege/$vertragId";
      path: "/vertraege/$vertragId";
      fullPath: "/vertraege/$vertragId";
      preLoaderRoute: typeof VertraegeVertragIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EigentuemerRoute: EigentuemerRoute,
  EingangRoute: EingangRoute,
  EinstellungenRoute: EinstellungenRoute,
  KostenRoute: KostenRoute,
  MehrRoute: MehrRoute,
  PreisatlasRoute: PreisatlasRoute,
  RechnerRoute: RechnerRoute,
  SanierungRoute: SanierungRoute,
  VersammlungRoute: VersammlungRoute,
  EntscheidungVergleichIdRoute: EntscheidungVergleichIdRoute,
  PreispruefungVertragIdRoute: PreispruefungVertragIdRoute,
  VergleicheVergleichIdRoute: VergleicheVergleichIdRoute,
  VertraegeVertragIdRoute: VertraegeVertragIdRoute,
  VergleicheIndexRoute: VergleicheIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
